import { render, staticRenderFns } from "./OpenIndicator.vue?vue&type=template&id=6b8976f5&"
import script from "./OpenIndicator.vue?vue&type=script&lang=js&"
export * from "./OpenIndicator.vue?vue&type=script&lang=js&"
import style0 from "./OpenIndicator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports